import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@mui/material';

interface ConfirmationDialogProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => Promise<void>;
    title: string;
    content: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ open, onCancel, onConfirm, title, content }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{content}</DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary" disabled={loading}>Cancel</Button>
                <Button onClick={handleConfirm} color="primary" disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : 'Confirm'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;